export default __webpack_public_path__ + "static/media/whiteKustomize.41b07b98.svg";